import * as React from 'react'

import IHierarchyParent from '~/client/src/shared/types/IHierarchyParent'

import LocationPickerField, {
  ILocationPickerFieldProps,
} from './LocationPickerField'

interface IProps extends Omit<
  ILocationPickerFieldProps,
  'selectedId' | 'onSelect' | 'onReset' | 'excludedSubtreeOf'
> {
  value?: IHierarchyParent | null
  onChange: (parent: IHierarchyParent | null) => void
  /**
   * The object being re-parented. It and everything under it are not offered: choosing
   * either would close a cycle in the hierarchy.
   */
  objectId?: string | null
  /**
   * Drop the field's reset icon, the one way of clearing the parent. For a map object,
   * having no parent is not an empty value but an orphan - it leaves the LBS hierarchy
   * and stops being placed - so the map passes this and offers reparenting only.
   */
  isClearDisabled?: boolean
}

/**
 * The one parent picker. Shared so the resource card's Parent field and the map's
 * Map Properties panel offer the same locations through the same control - they edit
 * the same `parent`, and two pickers that disagreed about what could be chosen read as
 * one of them being broken.
 */
const LocationParentPicker: React.FC<IProps> = ({
  value,
  onChange,
  objectId,
  isClearDisabled,
  ...fieldProps
}) => {
  return (
    <LocationPickerField
      {...fieldProps}
      selectedId={value?.parentId}
      excludedSubtreeOf={objectId}
      // A parent is named by id alone; parentType is no longer sent (STX1-1355).
      onSelect={parentId => onChange({ parentId })}
      onReset={isClearDisabled ? undefined : () => onChange(null)}
    />
  )
}

export default LocationParentPicker
